<script>
import StatusLabelBuilder from '@/components/Home/CustomDashboard/StatusLabelBuilder.vue';
import PermissionDeniedWidget from '@/components/Home/PermissionDeniedWidget.vue';

export default {
  components: { StatusLabelBuilder, PermissionDeniedWidget },
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dispLabels() {
      return this.labels && this.labels.length > 0;
    },
  },
};
</script>

<template>
  <div>
    <div class="status-label-box" v-if="dispLabels">
      <template v-for="(label, i) in labels" :key="i">
        <StatusLabelBuilder :label="label" v-if="label.accessible" />
        <PermissionDeniedWidget
          v-else
          :chartConfig="label"
          :class="['status-label-box-permission-denied']"
          variant="dark"
          :noIcon="true"
          :showTitle="true"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.status-label-box {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  padding: 1rem;
  background-color: $bg-secondary;
  border-radius: 1.0625rem;
  margin-top: 1.5rem;
}

.status-label-box-permission-denied {
  width: 16rem;
}
</style>
